import { render } from "./VgtPaginationPageInfo.vue?vue&type=template&id=30a8c12d"
import script from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"
export * from "./VgtPaginationPageInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__